import { Box } from "@chakra-ui/react";
import { useAppSelector } from "../../../store/hooks";

export default function SettingsSidebar({
  activeMenu,
  onMenuClick,
}: {
  activeMenu: string;
  onMenuClick: (id: string) => void;
}) {
  const { user } = useAppSelector((state) => state.auth);
  const isAdmin = user?.role === "admin";

  const menuItems = [
    // { id: "general", label: "General Settings" },
    ...(isAdmin ? [{ id: "users", label: "User Management" }] : []),
    { id: "password", label: "Change Password" },
  ];

  return (
    <Box
      w="100%"
      className="col-span-full md:col-span-1"
      bg="#E6ECF7"
      h={"fit-content"}
      p={6}>
      <Box fontSize="2xl" fontWeight="bold" color="gray.800" mb={8}>
        Settings
      </Box>

      <Box display="flex" flexDirection="column" gap={1}>
        {menuItems.map((item) => (
          <Box
            key={item.id}
            onClick={() => onMenuClick(item.id)}
            position="relative"
            px={4}
            py={3}
            borderRadius="lg"
            cursor="pointer"
            transition="all 0.2s"
            bg={activeMenu === item.id ? "blue.50" : "transparent"}
            color={activeMenu === item.id ? "gray.900" : "gray.700"}
            fontWeight={activeMenu === item.id ? "600" : "400"}
            _hover={{ bg: activeMenu === item.id ? "blue.50" : "gray.200" }}>
            {activeMenu === item.id && (
              <Box
                position="absolute"
                right={0}
                top={0}
                bottom={0}
                w="3px"
                bg="blue.600"
                borderLeftRadius="md"
              />
            )}
            {item.label}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
